// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-button-container {
  position: relative;
  width: fit-content;
  height: fit-content;
}

.menu-button-menu {
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: var(--input-element-gap);
  align-items: stretch;
  padding: var(--input-element-gap);
  box-sizing: border-box;
  background-color: var(--dialog-background-color);
  color: var(--text-color);
  font-size: var(--font-size-xl);
  border: 1px solid var(--border-color);
  border-radius: var(--dialog-border-radius);
  z-index: 1000;
  min-width: 180px;
  pointer-events: auto;
}

.menu-button-menu-top-left {
  bottom: 80%;
  right: 10%;
}

.menu-button-menu-top-right {
  bottom: 80%;
  left: 10%;
}

.menu-button-menu-bottom-left {
  top: 80%;
  right: 10%;
}

.menu-button-menu-bottom-right {
  top: 80%;
  left: 10%;
}

.menu-button-menu-title {
  font-size: var(--font-size-m);
  font-weight: bold;
  padding: var(--input-element-gap);
  white-space: nowrap;
}

.menu-button-option-divider {
  height: 1px;
  width: 100%;
  background-color: var(--border-color);
}

.menu-button-option {
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  align-items: center;
  font-size: var(--font-size-m);
  cursor: pointer;
  padding: var(--input-element-gap);
  border-radius: var(--dialog-border-radius);
  white-space: nowrap;
  font-weight: normal;

  &:hover {
    background-color: var(--light-grey);
  }
}

.menu-button-option-disabled {
  cursor: default;
  opacity: 0.5;

  &:hover {
    background-color: transparent;
  }
}

.menu-button-option-icon-container {
  min-width: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/menu-button/MenuButton.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,iCAAiC;EACjC,sBAAsB;EACtB,gDAAgD;EAChD,wBAAwB;EACxB,8BAA8B;EAC9B,qCAAqC;EACrC,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;;EAEnB;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,eAAe;EACf,YAAY;;EAEZ;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".menu-button-container {\n  position: relative;\n  width: fit-content;\n  height: fit-content;\n}\n\n.menu-button-menu {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  gap: var(--input-element-gap);\n  align-items: stretch;\n  padding: var(--input-element-gap);\n  box-sizing: border-box;\n  background-color: var(--dialog-background-color);\n  color: var(--text-color);\n  font-size: var(--font-size-xl);\n  border: 1px solid var(--border-color);\n  border-radius: var(--dialog-border-radius);\n  z-index: 1000;\n  min-width: 180px;\n  pointer-events: auto;\n}\n\n.menu-button-menu-top-left {\n  bottom: 80%;\n  right: 10%;\n}\n\n.menu-button-menu-top-right {\n  bottom: 80%;\n  left: 10%;\n}\n\n.menu-button-menu-bottom-left {\n  top: 80%;\n  right: 10%;\n}\n\n.menu-button-menu-bottom-right {\n  top: 80%;\n  left: 10%;\n}\n\n.menu-button-menu-title {\n  font-size: var(--font-size-m);\n  font-weight: bold;\n  padding: var(--input-element-gap);\n  white-space: nowrap;\n}\n\n.menu-button-option-divider {\n  height: 1px;\n  width: 100%;\n  background-color: var(--border-color);\n}\n\n.menu-button-option {\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  align-items: center;\n  font-size: var(--font-size-m);\n  cursor: pointer;\n  padding: var(--input-element-gap);\n  border-radius: var(--dialog-border-radius);\n  white-space: nowrap;\n  font-weight: normal;\n\n  &:hover {\n    background-color: var(--light-grey);\n  }\n}\n\n.menu-button-option-disabled {\n  cursor: default;\n  opacity: 0.5;\n\n  &:hover {\n    background-color: transparent;\n  }\n}\n\n.menu-button-option-icon-container {\n  min-width: 22px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
